import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewDocument from 'modules/documents/components/Documents/New'
import { Folder } from 'modules/documents/hooks/useGetFolders'

const New = () => {
  const { navigation } = useNavigation()
  const { employeeId, folder } = useOutletContext<{ employeeId: string; folder: Folder }>()
  const backRoute = navigation.employees.id.documents.list.fullPath({ id: employeeId })

  return <NewDocument employeeId={employeeId} folder={folder} backRoute={backRoute} />
}

export default New
